/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { ToastContainer } from 'react-toastify'
import { fetchData, toasterrormsg, toastsuccessmsg, useMenuIdPermissions } from '../../../../reusable'
import { PageTitle } from '../../../../_metronic/layout/core'
import { Tr } from '../../../../_metronic/i18n/Tr'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'

const ViewSupportSettings = () => {
  let t = Tr()
  const { menuIdEdit } = useMenuIdPermissions()

  const [error, setError] = useState(Object)
  const [serviceHours, setServiceHours] = useState('')
  const [globalAccessNumber, setGlobalAccessNumber] = useState('')
  const [globalAccessLoading, setGlobalAccessLoading] = useState(false)
  const [serviceHoursLoading, setServiceHoursLoading] = useState(false)

  const viewGlobalNumberAndServiceHoursApiCall = async () => {
    var res = await fetchData('admin/viewTimeAndPhoneGlobalSettings', {})

    if (res.status == '200') {
      var data = res.data
      setGlobalAccessNumber(data.globalAccessNumber)
      setServiceHours(data.serviceHours)
    } else {
      toasterrormsg(res.message)
    }
  }

  useEffect(() => {
    viewGlobalNumberAndServiceHoursApiCall()
  }, [])

  const removeError2 = (err: any) => {
    var tmp = Array.isArray(error) ? [...error] : [{}]
    if (!tmp[0]) tmp[0] = {}
    tmp[0][err] = ''
    setError(tmp)
  }

  const globalAccessValidate = () => {
    var isValid = true
    var errorTmp = Array.isArray(error) ? [...error] : [{}]
    
    if (globalAccessNumber == '') {
      errorTmp[0].globalAccessNumber = t('Global Access Number Is Required')
      isValid = false
    } else if (globalAccessNumber.length > 15) {
      errorTmp[0].globalAccessNumber = t('Global Access Number Is Not Valid')
      isValid = false
    }
    
    setError(errorTmp)

    if (isValid) {
      saveGlobalAccessHours()
    }
  }

  const serviceHourValidate = () => {
    let err = 0
    var errorTmp = Array.isArray(error) ? [...error] : [{}]

    if (serviceHours == '') {
      errorTmp[0].serviceHours = t('Service Hours Are Required')
      err = 1
    }

    setError(errorTmp)
    if (err === 0) {
      saveServiceHours()
    }
  }

  const saveGlobalAccessHours = async () => {
    setGlobalAccessLoading(true)
    const param = {
      globalAccessNumber: globalAccessNumber,
    }
    var res = await fetchData('admin/timeAndPhoneGlobalSettings', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      viewGlobalNumberAndServiceHoursApiCall()
      setGlobalAccessLoading(false)
    } else {
      toasterrormsg(res.message)
      setGlobalAccessLoading(false)
    }
  }

  const saveServiceHours = async () => {
    setServiceHoursLoading(true)
    const param = {
      serviceHours: serviceHours,
    }
    var res = await fetchData('admin/timeAndPhoneGlobalSettings', param)

    if (res.status == '200') {
      toastsuccessmsg(res.message)
      viewGlobalNumberAndServiceHoursApiCall()
      setServiceHoursLoading(false)
    } else {
      toasterrormsg(res.message)
      setServiceHoursLoading(false)
    }
  }

  useEffect(() => {
    document.title = 'Insayr | Support Settings'
  }, [])

  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Support Settings')}</PageTitle>

      <div className='row justify-content-between'>
        <div className='col-lg-6 col-md-12 mb-4'>
          <div className='card p-5 h-100'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Global Access Number')}</h3>
              </div>
            </div>

            <div className='card-body p-9'>
              <div className='col-lg-12'>
                <label className='fw-bold text-muted'>{t('Set Global Access Number')}</label>
                <div className='mt-5 mb-5'>
                  <PhoneInput
                    country={'in'}
                    inputProps={{
                      name: 'mobileNumber',
                      id: 'mobileNumber',
                      autoComplete: 'off',
                      className: `form-control w-100 py-6`,
                      placeholder: 'Enter Mobile Number',
                    }}
                    dropdownClass={`dropdown-menuphone`}
                    value={globalAccessNumber}
                    onChange={(value) => {
                      setGlobalAccessNumber(value)
                      removeError2('globalAccessNumber')
                    }}
                  />
                  <label className='text-danger'>
                    {error.length > 0 ? error[0].globalAccessNumber : ''}
                  </label>
                </div>
              </div>
              {menuIdEdit ? (
                <button
                  disabled={globalAccessLoading}
                  className='btn btn-success'
                  onClick={() => {
                    globalAccessValidate()
                  }}
                >
                  {!globalAccessLoading && t('Save')}
                  {globalAccessLoading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>

        <div className='col-lg-6 col-md-12 mb-4'>
          <div className='card h-100'>
            <div className='card-header'>
              <div className='card-title m-0'>
                <h3 className='fw-bolder m-0'>{t('Service Hours')}</h3>
              </div>
            </div>

            <div className='card-body p-9'>
              <div className='col-lg-12'>
                <label className='fw-bold text-muted'>{t('Set Service Hours')}</label>
                <div className='mt-5 mb-5'>
                  <textarea
                    placeholder='Enter Hours'
                    rows={10}
                    className='form-control form-control-solid w-100'
                    value={serviceHours}
                    onChange={(event: any) => {
                      setServiceHours(event.target.value)
                      removeError2('serviceHours')
                    }}
                  ></textarea>
                  <label className='text-danger'>
                    {error && error[0] && error[0].serviceHours ? error[0].serviceHours : ''}
                  </label>
                </div>
              </div>
              {menuIdEdit ? (
                <button
                  className='btn btn-success'
                  disabled={serviceHoursLoading}
                  onClick={() => {
                    serviceHourValidate()
                  }}
                >
                  {!serviceHoursLoading && t('Save')}
                  {serviceHoursLoading && (
                    <span className='indicator-progress' style={{ display: 'block' }}>
                      {t('Please wait...')}{' '}
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { ViewSupportSettings }